export default __webpack_public_path__ + "static/media/dccTrue.8a78d925.png";